import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import SortOrder from 'react-base-table/lib/SortOrder';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';

import tableArrow from '@adsk/bim360-matrix-react-assets/table-arrow.svg';
import './_SortIndicator.scss';

/**
 * SortIndicator for MatrixTable
 */
const SortIndicator = ({ sortOrder, className, style }) => {
  const cls = cn('SortIndicator', className, {
    'SortIndicator--descending': sortOrder === SortOrder.DESC
  });
  return (
    <SvgIcon className={cls} style={style}>
      {tableArrow}
    </SvgIcon>
  );
};

SortIndicator.propTypes = {
  sortOrder: PropTypes.oneOf([SortOrder.ASC, SortOrder.DESC]),
  className: PropTypes.string,
  style: PropTypes.object
};

export default SortIndicator;
